import React from 'react';
import { FieldGroup, TextInput } from 'library/ui';

export default function SlotsPicker({
    label,
    slotsAvailable = 1,
    setSlotsAvailable,
    disabled = false,
}: {
    label: string;
    slotsAvailable?: number;
    setSlotsAvailable: (slotsAvailable: number) => void;
    disabled?: boolean;
}) {
    return (
        <FieldGroup label={label}>
            <TextInput
                value={String(slotsAvailable)}
                onChange={(value) => {
                    const parsed = parseInt(value);
                    setSlotsAvailable(Number.isNaN(parsed) || parsed < 1 ? 1 : parsed);
                }}
                disabled={disabled}
            />
        </FieldGroup>
    );
}
